import React from "react";
import PropTypes from "prop-types";
//Material imports
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
// Limitless imports
import { groupSignUpPageStyles } from "../styles/groupSignup";
import { useSignUp } from "../../../hooks/SignUpHook";
import Overlay from "../overlay/overlay";
import SignUpForm from "../signup/SignUpForm";
import ConfirmSignUp from "../signup/VerifySignUp";
const GroupSignUpPage = ({
  groupHash,
  registrationUrl
}) => {
  var _values$email;
  const classes = groupSignUpPageStyles();
  const theme = useTheme();
  const stateCtx = useSignUp(groupHash);
  const {
    values,
    setLoading,
    getUserData,
    showOverlay,
    setShowOverlay,
    verifySignUp
  } = stateCtx;
  return /*#__PURE__*/React.createElement(Grid, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("img", {
    src: theme.assets ? theme.assets.logoImg : "",
    className: classes.logo
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.signUpFormWrapper,
    xs: 12
  }, verifySignUp ? /*#__PURE__*/React.createElement(ConfirmSignUp, {
    email: values === null || values === void 0 ? void 0 : (_values$email = values.email) === null || _values$email === void 0 ? void 0 : _values$email.value,
    registrationUrl: registrationUrl
  }) : /*#__PURE__*/React.createElement(SignUpForm, {
    stateCtx: stateCtx
  })), /*#__PURE__*/React.createElement(Overlay, {
    open: showOverlay,
    content: {
      userData: {
        ...getUserData(),
        groupHash
      }
    },
    onClose: (event, reason) => {
      setLoading(false);
      if (reason && reason === "backdropClick") {
        return;
      } else {
        setShowOverlay(false);
      }
    }
  }));
};
export default GroupSignUpPage;
GroupSignUpPage.propTypes = {
  groupHash: PropTypes.string.isRequired,
  registrationUrl: PropTypes.string
};